<template>
	<div class="job--edit--languages">
		<b-form-checkbox v-model="none" class="mb-3" @input="emitChangeEvent">
			Es sind keine Sprachkenntnisse nötig
		</b-form-checkbox>
		<template v-if="!none">
			<div class="job--edit--languages-items">
				<Item
					v-for="item in items"
					:key="item.id"
					:item="item"
					:meta="meta"
					@remove="remove(item)"
					@input="itemChanged(item, $event)"
				/>
			</div>
			<div v-if="!hasItems || itemsValid" class="job--edit--languages-autocomplete">
				<h3 v-if="items.length > 0">Weitere Sprache hinzufügen</h3>
				<VueSimpleSuggest
					v-model="keyword"
					:placeholder="keywordPlaceholder"
					:list="filteredLanguages"
					:debounce="250"
					:min-length="3"
					display-attribute="label"
					:styles="autoCompleteStyle"
					:max-suggestions="0"
					:prevent-submit="false"
					ref="autocomplete"
					@suggestion-click="languageClicked"
				/>
			</div>
		</template>
	</div>
</template>

<script>
import {arrayIsNotEmpty} from "@/helper/Array";
import VueSimpleSuggest from 'vue-simple-suggest'
import AutoCompleteStyle from "@/helper/style/AutoComplete";
import {isEmptyOrNull} from "@/helper/String";
import FormGroup from "@/vue/common/form/Group.vue";
import {search} from "@/helper/characteristic/Search";
import Item from "./language/Item";
import {isDefined} from "@/helper/Value";

export default {

	components: {
		VueSimpleSuggest,
		Item,
		FormGroup,
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		let none = false;
		let items = [];

		if (isDefined(this.value))
		{
			none = this.value.length === 0;

			_.forEach(this.value, item =>
			{
				items.push({
					id: item.item.id,
					item: item.item,
					specificities: item.specificities,
					requirement: item.requirement,
					valid: true,
				});
			});
		}

		return {
			none,
			items,
			keyword: '',
			autoCompleteStyle: AutoCompleteStyle.get(),
		};
	},

	computed: {
		hasItems ()
		{
			return this.items.length > 0;
		},
		keywordPlaceholder ()
		{
			return this.items.length === 0
				? 'Sprache hinzufügen... (mindestens 3 Zeichen)'
				: 'Weitere Sprache hinzufügen... (mindestens 3 Zeichen)';
		},
		filteredLanguages ()
		{
			const selectedIds = _.map(this.items, 'item.id');

			return _.filter(
				this.meta.language,
				characteristic =>
				{
					if (
						!isEmptyOrNull(this.keyword)
						&& !search(characteristic, this.keyword)
					)
					{
						return false;
					}

					return !_.includes(selectedIds, characteristic.id);
				}
			);
		},
		itemsValid ()
		{
			const valid = _.filter(this.items, item => item.valid);

			return arrayIsNotEmpty(this.items) && this.items.length === valid.length;
		},
		dataValid ()
		{
			return this.none || this.itemsValid;
		}
	},

	methods: {
		remove (item)
		{
			this.items = _.filter(this.items, i => i.id !== item.id);

			this.emitChangeEvent();
		},
		itemChanged (item, data)
		{
			this.$set(item, 'specificities', data.specificities);
			this.$set(item, 'requirement', data.requirement);
			this.$set(item, 'valid', data.valid);

			this.emitChangeEvent();
		},
		languageClicked (language)
		{
			this.items.push({
				id: language.id,
				item: language,
				valid: false
			});

			this.$nextTick(() =>
			{
				this.keyword = '';

				if (this.$refs.autocomplete)
				{
					this.$refs.autocomplete.setText('');
				}
			});

			this.emitChangeEvent();
		},
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', this.none ? [] : this.items);
		}
	}
}
</script>
